<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Notas de Serviço dos Parceiros</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Notas de serviço</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Parceiro</th>
                    <th scope="col" class="border-0">Número da nota</th>
                    <th scope="col" class="border-0">Número RPS</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0">Data de emissão</th>
                    <th scope="col" class="border-0">Período</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(noteExtract, index) in noteExtracts" :key="index">
                    <td></td>
                    <td class="text-left">{{ noteExtract.Partner.Name }}</td>
                    <td>{{ noteExtract.NFSeNumber }}</td>
                    <td>{{ noteExtract.RPSNumber }}</td>
                    <td>{{ noteExtract.Amount | currency }}</td>
                    <td>{{ noteExtract.EmissionDate | date }}</td>
                    <td>{{ noteExtract.Period | monthYear }}</td>
                    <td>
                      <span
                        :class="[
                          GetSpanClass(
                            noteExtract.NoteExtractPartnerStatus.Code
                          ),
                        ]"
                        >{{ noteExtract.NoteExtractPartnerStatus.Name }}</span
                      >
                      <span
                        class="td-span-style"
                        v-if="
                          noteExtract.NoteExtractPartnerStatusHistory
                            .UserInternal.Name != null &&
                          noteExtract.NoteExtractPartnerStatusHistory
                            .UserInternal.Name != undefined &&
                          noteExtract.NoteExtractPartnerStatusHistory
                            .UserInternal.Name != ''
                        "
                      >
                        <br />
                        POR
                        {{
                          noteExtract.NoteExtractPartnerStatusHistory
                            .UserInternal.Name | split(" ")
                        }}</span
                      >
                    </td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('NoteExtractPartner', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetNoteExtract(noteExtract.Id, true, false)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('NoteExtractPartner', 'Get')"
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetNoteExtract(noteExtract.Id, true, true)
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-if="
                              noteExtract.NoteExtractPartnerStatus.Code ==
                                '1' &&
                              $isAuthorize('NoteExtractPartner', 'UpdateStatus')
                            "
                            :class="loadingApprove ? 'disabled' : ''"
                            v-on:click.stop="
                              ConfirmUpdateNoteExtractPartnerStatus(
                                $event,
                                index,
                                true
                              )
                            "
                          >
                            <template v-if="loadingApprove">
                              <loader
                                :small="true"
                                :isLoading="loadingApprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-check mr-2"></i>
                              Aprovar
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-if="
                              noteExtract.NoteExtractPartnerStatus.Code ==
                                '1' &&
                              $isAuthorize('NoteExtractPartner', 'UpdateStatus')
                            "
                            :class="loadingDisapprove ? 'disabled' : ''"
                            v-on:click.stop="
                              ConfirmUpdateNoteExtractPartnerStatus(
                                $event,
                                index,
                                false
                              )
                            "
                          >
                            <template v-if="loadingDisapprove">
                              <loader
                                :small="true"
                                :isLoading="loadingDisapprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-times mr-2"></i>
                              Reprovar
                            </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      noteExtracts == null ||
                      noteExtracts == undefined ||
                      noteExtracts.length == 0
                    "
                  >
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormNoteExtract"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div>
          <div v-if="isCreating">
            <h4>Instruções</h4>
            <hr />
            <label
              >- Confira se o CNPJ do prestador de serviço é igual ao do
              parceiro selecionado</label
            >
            <label class="mb-4"
              >- Confira se o CNPJ do tomador de serviço é igual ao do Safe2Pay
              (31.037.942/0001-78)</label
            >
          </div>
          <h4>Informações da nota</h4>
          <hr />
          <ValidationObserver ref="formValidation">
            <d-form-row>
              <!-- Partner.Id -->
              <d-col md="6" class="form-group">
                <label>Parceiro</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-select
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.Partner.Id"
                    :disabled="isSeeing"
                  >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="partner in partners"
                      v-bind:value="partner.Id"
                      v-bind:key="partner.Id"
                    >
                      {{ partner.Name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- Period -->
              <d-col md="6" class="form-group">
                <label>Período</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-bind:inputClass="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.Period"
                    format="MMMM yyyy"
                    minimumView="month"
                    :disabled="isSeeing"
                  ></date-field>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- NFSeNumber -->
              <d-col md="6" class="form-group">
                <label>Número da nota</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    type="text"
                    v-model="infoNoteExtract.NFSeNumber"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- RPSNumber -->
              <d-col md="6" class="form-group">
                <label>Número RPS</label>
                <d-form-input
                  type="text"
                  v-model="infoNoteExtract.RPSNumber"
                  :disabled="isSeeing"
                />
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- Amount -->
              <d-col md="6" class="form-group">
                <label>Valor</label>
                <ValidationProvider
                  rules="required|min_value:0.01"
                  v-slot="{ errors, invalid }"
                >
                  <currency-input
                    :class="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    class="form-control"
                    v-model="infoNoteExtract.Amount"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- EmissionDate -->
              <d-col md="6" class="form-group">
                <label>Data de emissão</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-bind:inputClass="
                      validatedFormValidation | showValidateError(invalid)
                    "
                    v-model="infoNoteExtract.EmissionDate"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- NFSeUrl -->
            <d-form-row v-if="isCreating">
              <d-col md="12" class="form-group">
                <label>Arquivo</label>
                <b-form-file
                  type="file"
                  placeholder="Selecione ou arraste um arquivo"
                  drop-placeholder="Solte o arquivo aqui"
                  browse-text="Selecionar"
                  accept="application/pdf, text/plain"
                  @change="SelectNoteExtractFile($event, true)"
                  @input="SelectNoteExtractFile($event, false)"
                />
              </d-col>
            </d-form-row>
          </ValidationObserver>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddNoteExtractValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IdPartner" :value="null">
            <option :value="null" selected>Parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:key="partner.Id"
              v-bind:value="partner.Id"
            >
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field
            placeholder="Período"
            v-model="filter.Period"
            format="MMMM yyyy"
            minimumView="month"
          ></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeNoteExtractPartnerStatus" :value="null">
            <option :value="null" selected>Status</option>
            <option
              v-for="status in noteExtractPartnerStatus"
              v-bind:key="status.Code"
              v-bind:value="status.Code"
            >
              {{ status.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field
            placeholder="Data de Emissão Inicial"
            v-model="filter.EmissionInitialDate"
          ></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field
            placeholder="Data de Emissão Final"
            v-model="filter.EmissionEndDate"
          ></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('NoteExtractPartner', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova nota"
      v-on:click="OpenMNewNoteExtract()"
    >
      <i class="fa fa-plus"></i>
    </a>

    <b-modal
      id="mConfirm"
      title="Confirmar"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Motivo -->
      <ValidationObserver tag="form" ref="ReasonStep">
        <div v-if="mCurrentStepConfirm === 0">
          <div>
            <d-form-row>
              <d-col class="col-12">
                <h5>Motivo da Recusa</h5>
                <hr />
                <d-col md="12" class="form-group">
                  <ValidationProvider
                    rules="required|min:10|max:1000"
                    v-slot="{ errors, invalid }"
                  >
                    <b-form-textarea
                      :class="validatedReasonStep | showValidateError(invalid)"
                      type="text"
                      v-model="reason"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedReasonStep"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-col>
            </d-form-row>
          </div>
        </div>
      </ValidationObserver>

      <!-- Confirm - 10 -->
      <div v-if="mCurrentStepConfirm === 1">
        <h4>Confirmação</h4>
        <div>
          <d-form-row>
            <d-col class="col-12">
              <p class="account-type mb-2">Motivo da recusa: {{ reason }}</p>
            </d-col>
          </d-form-row>
        </div>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="BackStepRecuse()"
            :disabled="mCurrentStepConfirm === 0"
          >
            <i class="fas fa-arrow-left"></i>
          </b-button>

          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="ProcessNextStepRecuse()"
            v-if="mCurrentStepConfirm !== 1"
          >
            <i class="fas fa-arrow-right"></i>
          </b-button>
          <b-button
            type="button"
            class="btn btn-danger"
            v-on:click="UpdateNoteExtractPartnerStatus(index, approve, reason)"
            v-if="mCurrentStepConfirm === 1"
            :disabled="loadingRecuse"
          >
            <template v-if="!loadingRecuse">Reprovar</template>
            <template v-else>
              <loader :small="true" :isLoading="loadingRecuse"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "note-extract-partners",
  data: function () {
    return {
      mCurrentStepConfirm: 0,
      validatedReasonStep: false,
      loadingRecuse: null,
      reason: "",
      approve: null,
      index: null,

      countFilter: 0,
      filter: {
        IdPartner: null,
        Period: null,
        EmissionInitialDate: null,
        EmissionEndDate: null,
        CodeNoteExtractPartnerStatus: null,
      },
      validatedFormValidation: false,
      loadingDownload: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      loadingApprove: false,
      loadingDisapprove: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      noteExtracts: [],
      partners: [],
      noteExtractPartnerStatus: [],
      infoNoteExtract: {
        Partner: {
          Id: null,
        },
        RPSNumber: null,
        NFSeNumber: null,
        Amount: null,
        EmissionDate: null,
        Period: null,
        EmissionInitialDate: null,
        EmissionEndDate: null,
        NFSeUrl: null,
      },
      noteExtractFile: null,
      isSeeing: false,
      isCreating: false,
      modalTitle: "Nova nota",
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListNoteExtract();
    },
    "pagination.RowsPerPage": function () {
      this.ListNoteExtract();
    },
  },
  mounted() {
    if (this.$route.query.listPending == "true") {
      this.listPending = true;
      this.filter.CodeNoteExtractPartnerStatus = "1";
    }
    this.ListNoteExtract();
    this.ListNoteExtractPartnerStatus();
    this.ListPartner();
  },
  methods: {
    SelectNoteExtractFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (file.type == "application/pdf" || file.type == "text/plain") {
        this.noteExtractFile = file;
      } else {
        this.$makeToast(
          "O arquivo selecionado não é um PDF ou TXT válido",
          "danger",
          "Nota de serviço"
        );
      }
    },
    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    OpenMNoteExtract: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormNoteExtract");
    },
    OpenMNewNoteExtract: function () {
      this.ResetInfoNoteExtract();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Nova nota";
      this.OpenMNoteExtract();
    },
    ResetInfoNoteExtract: function () {
      this.infoNoteExtract = {
        Partner: {
          Id: null,
        },
        RPSNumber: null,
        NFSeNumber: null,
        Amount: 0,
        EmissionDate: null,
        Period: null,
        EmissionInitialDate: null,
        EmissionEndDate: null,
        NFSeUrl: null,
      };
    },
    AddNoteExtractValidated: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          if (
            this.noteExtractFile != null &&
            this.noteExtractFile != undefined
          ) {
            this.AddNoteExtract();
          } else {
            this.$makeToast(
              "Selecione um arquivo",
              "danger",
              "Nota de serviço do parceiro"
            );
          }
        }
      });
    },
    AddNoteExtract() {
      if (this.isCreating) {
        // Add
        this.loadingModal = true;
        let noteExtract = this.infoNoteExtract;
        noteExtract = JSON.parse(JSON.stringify(noteExtract));
        delete noteExtract.NFSeUrl;
        var formData = this.GetFormData(noteExtract);
        formData.append(
          "File",
          this.noteExtractFile,
          this.noteExtractFile.name
        );
        this.$store
          .dispatch("AddNoteExtractPartner", formData)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar a nota",
              "success",
              "Nota de serviço do parceiro"
            );
            this.ListNoteExtract();
            this.$bvModal.hide("mFormNoteExtract");
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível adicionar a nota",
              "danger",
              "Nota de serviço do parceiro",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListNoteExtract();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        "Object.Partner.Id": this.filter.IdPartner,
        "Object.Period": this.filter.Period,
        "InitialDate": this.filter.EmissionInitialDate,
        "EndDate": this.filter.EmissionEndDate,
        "Object.NoteExtractPartnerStatus.Code": this.filter
          .CodeNoteExtractPartnerStatus,
      };

      this.$store
        .dispatch("ReportNoteExtractPartner", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ListNoteExtract: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.Period)) this.countFilter++;
      if (hasValue(this.filter.EmissionInitialDate)) this.countFilter++;
      if (hasValue(this.filter.EmissionEndDate)) this.countFilter++;
      if (hasValue(this.filter.CodeNoteExtractPartnerStatus))

      if(hasValue(this.filter.EmissionInitialDate) && hasValue(this.filter.EmissionEndDate)){
          if (this.filter.EmissionInitialDate > this.filter.EmissionEndDate) {
          this.$makeToast("A data Final deve ser maior que a data Inicial.",
          "danger",
          "Data incorreta.",);
          this.loadingList = false;
          return;
        }
      }

      this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Partner.Id": this.filter.IdPartner,
          "Object.Period": this.filter.Period,
          "InitialDate": this.filter.EmissionInitialDate,
          "EndDate": this.filter.EmissionEndDate,
          "Object.NoteExtractPartnerStatus.Code": this.filter
            .CodeNoteExtractPartnerStatus,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListNoteExtractPartner", { params: data })
        .then(
          (response) => {
            this.noteExtracts = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar as notas",
              "danger",
              "Notas de serviço dos parceiros",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ListNoteExtractPartnerStatus: function () {
      this.$store
        .dispatch("ListNoteExtractPartnerStatus")
        .then((response) => {
          this.noteExtractPartnerStatus = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de status de nota de serviço",
            error
          );
        });
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        IdPartner: null,
        Period: null,
        EmissionInitialDate: null,
        EmissionEndDate: null,
        CodeNoteExtractPartnerStatus: this.listPending ? "1" : null,
      };
      this.ListNoteExtract();
    },
    GetSpanClass: function (codeNoteExtractPartnerStatus) {
      let variation = "badge badge-warning";
      if (codeNoteExtractPartnerStatus == "2") {
        variation = "badge badge-success";
      } else if (codeNoteExtractPartnerStatus == "3") {
        variation = "badge badge-danger";
      }
      return variation;
    },
    GetNoteExtract: function (id, seeing, download) {
      if (download) this.loadingDownload = true;
      else this.loadingModal = true;
      if (!download) {
        if (seeing == true) {
          this.isSeeing = true;
          this.modalTitle = "Detalhes da nota";
        }
        this.isCreating = false;
        this.ResetInfoNoteExtract();
        this.OpenMNoteExtract();
      }

      this.$store
        .dispatch("GetNoteExtractPartner", { id: id })
        .then((response) => {
          this.infoNoteExtract = response;

          if (download && hasValue(response.NFSeUrl)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Nota de serviço do parceiro"
            );
            window.open(response.NFSeUrl, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações da nota",
            "danger",
            "Nota de serviço do parceiro",
            error
          );
        })
        .finally(() => {
          if (download) this.loadingDownload = false;
          else this.loadingModal = false;
        });
    },
    OpenModalReprove: function (id, isApprove) {
      this.index = id;
      this.approve = isApprove;

      this.$bvModal.show("mConfirm");
    },
    HideModalConfirm: function () {
      this.$bvModal.hide("mConfirm");
    },
    ConfirmUpdateNoteExtractPartnerStatus: function (e, i, approve) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          approve ? "aprovar" : "reprovar"
        } esta nota de serviço?`,
        "Confirmar",
        approve ? this.UpdateNoteExtractPartnerStatus : this.OpenModalReprove,
        i,
        approve
      );
    },
    UpdateNoteExtractPartnerStatus: function (i, approve, reasonReprove) {
      let codeNoteExtractPartnerStatus = "";
      let noteExtractPartner = this.noteExtracts[i];
      let reason = "";

      this.HideModalConfirm();

      if (approve) {
        this.loadingApprove = true;
        codeNoteExtractPartnerStatus = "2";
      } else {
        this.loadingDisapprove = true;
        codeNoteExtractPartnerStatus = "3";
        reason = reasonReprove;
      }

      let infoNoteExtractPartner = {
        Id: noteExtractPartner.Id,
        Partner: {
          Id: noteExtractPartner.Partner.Id,
          ResponsibleName: noteExtractPartner.Partner.ResponsibleName,
        },
        NoteExtractPartnerStatus: {
          Code: codeNoteExtractPartnerStatus,
        },
        Reason: reason,
        Period: noteExtractPartner.Period
      };

      this.$store
        .dispatch("UpdateNoteExtractPartnerStatus", infoNoteExtractPartner)
        .then(() => {
          this.$makeToast(
            "Sua resposta foi processada com sucesso",
            "success",
            "Notas de serviço dos parceiros"
          );
          this.ListNoteExtract();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao processar sua resposta",
            error
          );
        })
        .finally(() => {
          if (approve) this.loadingApprove = false;
          else this.loadingDisapprove = false;
        });
    },
     NextStepRecuse: function () {
      if (this.mCurrentStepConfirm < 1) {
        this.mCurrentStepConfirm += 1;
      }
    },
    BackStepRecuse: function () {
      if (this.mCurrentStepConfirm >= 1) {
        this.mCurrentStepConfirm -= 1;
      }
    },
    ProcessNextStepRecuse: function (nextStep = null) {
      this.validatedReasonStep = true;
      this.CheckValidityRecuse("ReasonStep", nextStep);
    },
    CheckValidityRecuse(step, nextStep) {
      if (step == "ReasonStep") {
        this.$refs.ReasonStep.validate().then((isValid) => {
          if (!isValid) {
            this.validatedReasonStep = true;
          } else {
            if (nextStep == null) {
              this.NextStepRecuse();
            } else {
              this.mCurrentStepConfirm = nextStep;
            }
            this.validatedReasonStep = false;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.td-span-style {
  font-size: 8pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NoteExtractPartners.vue